import "./prasora-wsi2.scss";

import m from "mithril";
import Swal from "sweetalert2";

import svg from "../svg";
import modal from "../modal/modal";
import dp from "../datepicker/datepicker";
import pf from "../pf";
import prsorawsiblock from "../prasora-wsi-block/prasora-wsi-block";

export default () => {
    let fullwsi = null;
    let ws = null;
    let wis = null;
    let wslist = null;
    let wstype = null;
    let initiated = false;
    let showmodal = false;
    let updating = false;
    let UpdateWSinDS = null;

    function UpdateFixedDate(wi) {
        UpdateWorkstepInstance(wi, "SetFixedDate", wi.expectedon);
    }

    function UpdateCommitDate(wi) {
        UpdateWorkstepInstance(wi, "Reschedule", wi.committedon);
    }

    function UpdateRemarks(wi) {
        UpdateWorkstepInstance(wi, "Remarks", wi.remarks);
    }

    function UpdateNotRequired(wi) {
        UpdateWorkstepInstance(wi, "NotRequired");
    }

    function UpdateCompleted(wi) {
        UpdateWorkstepInstance(wi, "Complete");
    }

    async function UpdateWorkstepInstance(wi, actionname, value) {
        await pf.APIAction("UpdateWorkstepInstance", {
            id: wi.iid,
            actionname: actionname,
            wf: wi.wf,
            value: value
        }).then(r => {
            if (r)
                UpdateWSinDS(r);
        });
    }

    return {
        view: v => {

            if (!initiated) {
                ws = v.attrs.ws;
                wis = v.attrs.wis;
                wslist = v.attrs.wslist;
                fullwsi = v.attrs.fullwsi;
                UpdateWSinDS = v.attrs.UpdateWSinDS;
                wstype = v.attrs.wstype;
                initiated = true;
                // console.log(wstype);
            }

            if (updating) {
                return m("a.prasora-wsi", [m(svg, {
                    name: "loader"
                })]);
            } else {



                if (showmodal) {
                    // console.log(wis);
                    return m(modal, [
                        m(".modal-wsi2", [
                            m(".modal-wsi2-header", [
                                m(".modal-wsi2-title", `${ws.name}${wis.length > 1? ` (${wis.length})`: ""}`),
                                m(".modal-cancel-button", {
                                    onclick: () => {
                                        showmodal = false;
                                    }
                                }, [m(svg, {
                                    name: "delete"
                                })])
                            ]),
                            m(".modal-wsi2-body", [
                                m(".modal-wsi-content", [
                                    wis.map(wi => {

                                        let {
                                            allowedEditingExpectedOn,
                                            allowedEditingCommittedOn,
                                            cancancel,
                                            cando
                                        } = GetWiInformation(wi);


                                        // console.log(cando, v.attrs.isDue);

                                        return m(".modal-wsi2-wi-wrapper", [
                                            m(".activity-title", `${wi.name} | Due for: ${wi.duefor || "Unassigned"}`),
                                            m(".activity-details", [
                                                m(".section-1", [
                                                    m(".field-date-section", [
                                                        m(".date-title", "Target Date"),
                                                        allowedEditingExpectedOn ? m(dp, {
                                                            class: ".date-value",
                                                            options: {
                                                                OnUpdateEvent: (val) => {
                                                                    wi.expectedon_old = wi.expectedon;
                                                                    wi.expectedon = val;
                                                                    UpdateFixedDate(wi);
                                                                },
                                                                defaultDate: wi.expectedon
                                                            },
                                                        }) : m("span", moment(wi.expectedon).format('D MMM YYYY'))
                                                    ]),
                                                    wi.completed == "True" ?
                                                    m(".field-date-section", [
                                                        m(".date-title", "Completed On Date"),
                                                        m("span", moment(wi.completedon).format('D MMM YYYY'))
                                                    ]) :
                                                    m(".field-date-section", [
                                                        m(".date-title", "Committed Date"),
                                                        allowedEditingCommittedOn ? m(dp, {
                                                            class: ".date-value",
                                                            options: {
                                                                OnUpdateEvent: (val) => {
                                                                    wi.committedon_old = wi.committedon;
                                                                    wi.committedon = val;
                                                                    UpdateCommitDate(wi);
                                                                },
                                                                defaultDate: wi.committedon || null
                                                            }
                                                        }) : m("span", wi.committedon ? moment(wi.committedon).format('D MMM YYYY') : "Not Set")
                                                    ]),
                                                    m(".field-date-section", [
                                                        m(".date-title", "Expected Date"),
                                                        m("span", moment(wi.possibleon).format('D MMM YYYY'))
                                                    ])
                                                ]),
                                                m(".remarks-sections", [
                                                    m(".sector-2-title", "Previous Remarks"),
                                                    m("textarea.previous-remarks", wi.remarks),
                                                ]),
                                                m(".remarks-sections", [
                                                    m(".sector-2-title", "Add New Remark"),
                                                    m("textarea.new-remark", {
                                                        value: wi.newremarks,
                                                        oninput: (e) => {
                                                            wi.newremarks = e.target.value;
                                                        }
                                                    }),
                                                    wi.newremarks && m("button.add-remark-button", {
                                                        type: "button",
                                                        onclick: () => {
                                                            wi.remarks_old = wi.remarks;
                                                            if (wi.remarks)
                                                                wi.remarks = `${wi.currentuser} (${moment().format('D MMM YYYY')}): ${wi.newremarks}
${wi.remarks}`;
                                                            else
                                                                wi.remarks = `${wi.currentuser} (${moment().format('D MMM YYYY')}): ${wi.newremarks}`;

                                                            wi.newremarks = null;
                                                            UpdateRemarks(wi);
                                                        }
                                                    }, "Add Remark")
                                                ]),
                                                m(".section-4", [
                                                    cancancel ? m("button.icon-button.not-required", {
                                                        type: "button",
                                                        onclick: () => {
                                                            Swal.fire({
                                                                title: 'Are you sure??',
                                                                text: "You won't be able to revert this!",
                                                                type: 'warning',
                                                                showCancelButton: true,
                                                                confirmButtonColor: '#d33',
                                                                cancelButtonColor: '#3085d6',
                                                                confirmButtonText: 'Yes, this activity is not required!'
                                                            }).then((result) => {
                                                                if (result.value) {
                                                                    UpdateWSinDS({
                                                                        action: "remove",
                                                                        wi: wi
                                                                    });
                                                                    UpdateNotRequired(wi);
                                                                }
                                                            })
                                                        }
                                                    }, ["Not Required"]) : null,
                                                    (!cando && !wi.isdue) ? m("span", "Not Due") : null,
                                                    (cando && wi.isdue) ? (wi.link ? m("a.icon-button.completion-button", {
                                                            href: wi.link,
                                                            target: "_blank"
                                                        }, ["Complete This Activity"]) :
                                                        m("button.icon-button.completion-button", {
                                                            type: "button",
                                                            onclick: () => {
                                                                Swal.fire({
                                                                    title: 'Are you sure??',
                                                                    text: "False information is not acceptable",
                                                                    type: 'info',
                                                                    showCancelButton: true,
                                                                    confirmButtonText: 'Yes, this activity is completed!'
                                                                }).then((result) => {
                                                                    if (result.value) {

                                                                        UpdateWSinDS({
                                                                            action: "complete",
                                                                            wi: wi
                                                                        });

                                                                        UpdateCompleted(wi);
                                                                    }
                                                                })
                                                            }
                                                        }, ["Complete This Activity"])) : null,
                                                ])
                                            ])
                                        ])
                                    })
                                ])
                            ])
                        ])
                    ])
                } else {

                    if (wstype == 3 && wis.length == 1) {
                        let wi = wis[0];
                        let {
                            allowedEditingExpectedOn,
                            allowedEditingCommittedOn,
                            cancancel,
                            cando
                        } = GetWiInformation(wi);

                        // console.log(wi.completed);

                        return m(".wsi-3-wrapper", [
                            m(".target-date-section", [
                                m(".date-title", "Target"),
                                allowedEditingExpectedOn ? m(dp, {
                                    class: ".date-value",
                                    options: {
                                        OnUpdateEvent: (val) => {
                                            wi.expectedon_old = wi.expectedon;
                                            wi.expectedon = val;
                                            UpdateFixedDate(wi);
                                        },
                                        defaultDate: wi.expectedon
                                    },
                                }) : m(dp, {
                                    class: ".date-value",
                                    options: {
                                        disabled: true,
                                        OnUpdateEvent: (val) => {
                                            wi.expectedon_old = wi.expectedon;
                                            wi.expectedon = val;
                                            UpdateFixedDate(wi);
                                        },
                                        defaultDate: wi.expectedon
                                    },
                                })
                                // m("span", moment(wi.expectedon).format('D MMM YYYY'))
                            ]),
                            m(".completed-date-section", [
                                wi.completed ? [
                                    m(".date-title", "Completed"),
                                    m(dp, {
                                        class: ".date-value",
                                        options: {
                                            disabled: true,
                                            OnUpdateEvent: (val) => {},
                                            defaultDate: wi.completedon || null
                                        }
                                    })
                                ] : [m(".date-title", "Committed"),
                                    allowedEditingCommittedOn ? m(dp, {
                                        class: ".date-value",
                                        options: {
                                            OnUpdateEvent: (val) => {
                                                wi.committedon_old = wi.committedon;
                                                wi.committedon = val;
                                                UpdateCommitDate(wi);
                                            },
                                            defaultDate: wi.committedon || null
                                        }
                                    }) : m(dp, {
                                        class: ".date-value",
                                        options: {
                                            OnUpdateEvent: (val) => {
                                                wi.committedon_old = wi.committedon;
                                                wi.committedon = val;
                                                UpdateCommitDate(wi);
                                            },
                                            defaultDate: wi.committedon || null
                                        }
                                    })
                                ]
                                // m("span", wi.committedon ? moment(wi.committedon).format('D MMM YYYY') : "Not Set")
                            ]),
                            m(".final-section", [
                                m("a.show-detail", {
                                    onclick: () => {
                                        showmodal = true;
                                    }
                                }, "Show Detail")
                            ])
                        ]);
                    } else {

                        let hasData = (wis.length > 0);

                        let maxexpected = null;
                        let maxcommittedon = null;
                        let delay = 0;
                        let status = "";
                        let maxcompleted = null;
                        let numberActivities = 0;
                        let numberCompleted = 0;
                        let percentComplete = 0;
                        let hasremarks = false;
                        let hasDue = false;

                        if (hasData) {

                            maxexpected = Math.max.apply(Math, wis.filter(a => !!a.expectedon).map(a => a.expectedon ? new Date(a.expectedon) : null));
                            maxcompleted = Math.max.apply(Math, wis.filter(a => !!a.completedon).map(a => a.completedon ? new Date(a.completedon) : null));
                            maxcommittedon = Math.max.apply(Math, wis.filter(a => !!a.committedon).map(a => a.committedon ? new Date(a.committedon) : null));

                            // console.log(maxcommittedon, wis);

                            numberActivities = wis.length;
                            numberCompleted = wis.filter(a => !!a.completed).length;
                            percentComplete = Math.round((numberCompleted * 100) / numberActivities)

                            delay = Math.max.apply(Math, wis.filter(a => !!a.posdel).map(a => a.posdel));

                            hasDue = wis.filter(a => a.isdue)


                            if (maxcompleted == "-Infinity" || !maxcompleted)
                                maxcompleted = "";
                            else maxcompleted = moment(maxcompleted).format('D MMM YYYY');

                            if (maxexpected == "-Infinity" || !maxexpected)
                                maxexpected = "";
                            else maxexpected = moment(maxexpected).format('D MMM YYYY');

                            if (maxcommittedon == "-Infinity" || !maxcommittedon)
                                maxcommittedon = "";
                            else maxcommittedon = moment(maxcommittedon).format('D MMM YYYY');


                            status = "ontime";
                            if (delay <= 0) {
                                if (v.attrs.isDue) {
                                    status = "due";
                                }
                            } else {
                                if (Math.abs(delay) <= 1) {
                                    status = "intime";
                                } else {
                                    status = "late";
                                }
                            }

                            if (delay == 0)
                                delay = "";

                            hasremarks = (wis.filter(a => !!a.remarks).length > 0);

                            if (v.attrs.isDue) {
                                status = `${status} activity-is-due`;
                            }

                            if (hasremarks)
                                status = `${status} has-remarks`;
                        }


                        return m(".prasora_wsi2-wrapper", {
                            onclick: () => {
                                showmodal = true;
                            }
                        }, [
                            hasData ? [
                                m(".d1", `${maxexpected} ${delay? `(${delay})`:""}${wis.length > 1? ` [${wis.length}]`:""}`),
                                m(".activity-status", {
                                    style: `width: ${percentComplete}%;`
                                }),
                                m(".d", {
                                    class: hasremarks ? "has-remarks" : ""
                                }),
                                m(".d2", {
                                        class: (maxcompleted || maxcommittedon) ? "hasdate" : ""
                                    },
                                    maxcompleted ? [
                                        m(svg, {
                                            name: "activitydone"
                                        }),
                                        m("span.completed-date", maxcompleted)
                                    ] : [(v.attrs.isDue ? m(svg, {
                                            name: "activitydue"
                                        }) : m(svg, {
                                            name: "blank"
                                        })),
                                        m("span.committed-date", maxcommittedon)
                                    ])
                            ] : null
                        ]);
                    }
                }
            }
        }
    }
}

function GetWiInformation(wi) {
    let allowedEditingExpectedOn = false;
    let allowedEditingCommittedOn = false;
    let cando = false;
    let cancancel = false;
    if (wi.cando && !wi.completed) {
        allowedEditingCommittedOn = true;
    }
    if (wi.cansettarget && !wi.completed) {
        allowedEditingExpectedOn = true;
    }
    if (wi.cansettarget && !wi.completed)
        cancancel = true;
    if ((wi.cando && !wi.completed && wi.isdue))
        cando = true;
    return {
        allowedEditingExpectedOn,
        allowedEditingCommittedOn,
        cancancel,
        cando
    };
}